
import Vue from 'vue';
import { DataWithHref } from '@root/modules/headlines/types/headlines';
import { HeadlineAuthor, HeadlineTitle, HeadlineImage, HeadlineLead } from '@headlines/components/fragments';

interface Data {
  leadLimit: number;
}

interface Props {
  headline: DataWithHref;
  pictureSrcset: Record<string, unknown>;
  template: string;
}

interface Computed {
  ptContent: boolean;
}

export default Vue.extend<Data, unknown, Computed, Props>({
  components: {
    HeadlineAuthor,
    HeadlineImage,
    HeadlineTitle,
    HeadlineLead,
  },
  props: {
    headline: {
      type: Object,
      required: true,
    },
    pictureSrcset: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    template: {
      type: String,
      required: false,
      default: () => 'horizontal',
    },
  },
  data() {
    return {
      leadLimit: 140,
    };
  },
  computed: {
    ptContent() {
      return !!(this.headline.settings && this.headline.settings.find((setting) => setting.key === 'icon.reklama')?.value);
    },
  },
});
